import AppContext from 'context/Context';
import is from 'is_js';
import React, { useContext, useEffect } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { CloseButton } from 'components/common/Toast';
import Error404 from 'components/errors/Error404';
import Error500 from 'components/errors/Error500';
import ErrorLayout from './ErrorLayout';
import paths from 'routes/paths';
import { DonorInformationPage } from 'components/Home/donor-information';
import { DonationPaymentPage } from 'components/Home/DonationPayment';
import { DonationThanksPage } from 'components/Home/DonationThanks';
import { DonationFailedPage } from 'components/Home/DonationFailed';
import Home from 'components/Home';
import { DonationContextProvider } from 'context/DonationContextProvider';
import GiftAid from 'components/gift-aid';
import { AuthChoiceModal } from 'components/Home/AuthChoiceModal';
import { ResetPasswordPage } from 'components/Home/ResetPassword';
import { ProfilePage } from 'components/Home/Profile';

const Layout = () => {
  const HTMLClassList = document.getElementsByTagName('html')[0].classList;
  const {
    config: { navbarPosition }
  } = useContext(AppContext);

  useEffect(() => {
    if (is.windows()) {
      HTMLClassList.add('windows');
    }
    if (is.chrome()) {
      HTMLClassList.add('chrome');
    }
    if (is.firefox()) {
      HTMLClassList.add('firefox');
    }
    if (is.safari()) {
      HTMLClassList.add('safari');
    }
  }, [HTMLClassList]);

  useEffect(() => {
    if (navbarPosition === 'double-top') {
      HTMLClassList.add('double-top-nav-layout');
    }
    return () => HTMLClassList.remove('double-top-nav-layout');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navbarPosition]);

  return (
    <>
      <DonationContextProvider>
        <AuthChoiceModal />
        <Routes>
          <Route element={<ErrorLayout />}>
            <Route path={paths.notFound} element={<Error404 />} />
            <Route path={paths.serverError} element={<Error500 />} />
          </Route>

          <Route path="/" element={<Home />} />
          {/* Campaign links: /<slug> is looked up in donation_links by the
              quick donation form; an unknown slug just shows the normal page.
              Static routes above and below still win over this one. */}
          <Route path="/:linkSlug" element={<Home />} />
          <Route
            path={paths.donation.DONOR_INFORMATION}
            element={<DonorInformationPage />}
          />
          <Route
            path={paths.donation.PAYMENT}
            element={<DonationPaymentPage />}
          />
          <Route
            path={paths.donation.THANKS}
            element={<DonationThanksPage />}
          />
          <Route
            path={paths.donation.FAILED}
            element={<DonationFailedPage />}
          />
          <Route
            path={paths.donation.PROFILE}
            element={<ProfilePage />}
          />
          <Route
            path={paths.donation.RESET_PASSWORD}
            element={<ResetPasswordPage />}
          />

          <Route path="*" element={<Navigate to={paths.notFound} replace />} />
        </Routes>
      </DonationContextProvider>

      <ToastContainer
        closeButton={CloseButton}
        icon={false}
        position={toast.POSITION.BOTTOM_LEFT}
      />
    </>
  );
};

export default Layout;
